import React from 'react';
import { Toggle } from 'requests/toggleServiceClient';

export type TogglesContext = Toggle[];
export const TogglesContext = React.createContext<TogglesContext>([]);
